<template>
  <div class="benefit-wrap">
    <div class="benefit-title">Benefit Anggota</div>

    <!-- CARD -->
    <template v-if="benefit || isSuccessGetBenefit">
      <template v-if="isMobile()">
        <img :src="bannerMobile2?.image_url" alt="" style="border-radius: 8px; cursor: pointer; width: 100%" @click="showBenefitModal = true" />
      </template>
      <template v-else>
        <img :src="banner2?.image_url" alt="" style="border-radius: 16px; cursor: pointer; width: 100%" @click="showBenefitModal = true" />
      </template>
    </template>
    <template v-else>
      <template v-if="isMobile()">
        <img :src="bannerMobile1?.image_url" alt="" style="border-radius: 8px; width: 100%; cursor: pointer;" @click="showHowTo = true" v-if="!profile"/>
        <button :disabled="isDisabled" style="border-radius: 8px; width: 100%; cursor: pointer;" @click="activateBenefit" v-else>
          <img :src="bannerMobile3?.image_url" alt="" style="border-radius: 16px; cursor: pointer; width: 100%;" />
        </button>
      </template>
      <template v-else>
        <img :src="banner1?.image_url" alt="" style="border-radius: 16px; cursor: pointer; width: 100%;" @click="showHowTo = true" v-if="!profile"/>
        <button :disabled="isDisabled" style="border-radius: 16px; cursor: pointer; width: 100%;" @click="activateBenefit" v-else>
          <img :src="banner3?.image_url" alt=""  style="border-radius: 16px; cursor: pointer; width: 100%;" />
        </button>
      </template>
    </template>
  </div>

  <BenefitHowToModal :show="showHowTo" @close="showHowTo = false" />
  <BenefitDetailModal :show="showBenefitModal" :data="detailBenefit" :showChannels="false" @close="showBenefitModal = false" />
  <BenefitSuccessModal :show="showSuccessModal" :benefit="successActivateBenefit" @close="closeSuccessModal" />
  <Loader v-if="isLoad" />
</template>

<script>
import BenefitHowToModal from './BenefitHowToModal.vue'
import BenefitDetailModal from './BenefitDetailModal.vue'
import BenefitSuccessModal from './BenefitSuccessModal.vue'
import { bannerCode } from '@/store'
import device from '@/mixins/isMobile'
import Loader from './loader.vue'

export default {
  name: 'BenefitAnggotaCard',
  components: { BenefitHowToModal, BenefitDetailModal, BenefitSuccessModal, Loader },
  props: {
    benefit: { type: Array, default: null }
  },

  data () {
    return {
      showHowTo: false,
      showBenefitModal: false,
      showSuccessModal: false,
      banner1: null,
      banner2: null,
      banner3: null,
      bannerMobile1: null,
      bannerMobile2: null,
      bannerMobile3: null,
      detailBenefit: null,
      successActivateBenefit: null,
      isSuccessGetBenefit: false,
      isDisabled: false,
      isLoad: false,
    }
  },
  mixins: [device],
  computed: {
    activeUntilText () {
      if (!this.activeUntil) return ''
      const d = typeof this.activeUntil === 'string' ? new Date(this.activeUntil) : this.activeUntil
      if (!d || isNaN(d.getTime())) return ''
      const months = [
        'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
        'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
      ]
      const dd = d.getDate().toString().padStart(2, '0')
      return `${dd} ${months[d.getMonth()]} ${d.getFullYear()}`
    },
    profile() {
      return this.$store.state.profile
    }
  },

  methods: {
    async getBanner({ code, data }) {
      const res = await this.$store.dispatch('getBanners', code)
      this[data] = res?.data
    },
    async activateBenefit() {
      this.isDisabled = true
      this.isLoad = true
      const res = await this.$store.dispatch('activateBenefit')
      this.isDisabled = false
      this.isLoad = false
      if (res?.code === 200) {
        this.isSuccessGetBenefit = true
        this.showSuccessModal = true
        this.successActivateBenefit = res?.data
      } else {
        this.$toast.error(res?.message || 'Aktivasi benefit gagal. Silakan coba lagi.')
      }
    },
    closeSuccessModal() {
      this.showSuccessModal = false
      this.successActivateBenefit = null
    }
  },

  async mounted() {
    await Promise.all([
      this.getBanner({ code: bannerCode.bnrHomeNoKta, data: 'banner1' }),
      this.getBanner({ code: bannerCode.bnrHomeActvKta, data: 'banner2' }),
      this.getBanner({ code: bannerCode.bnrHomeOldKta, data: 'banner3' }),
      this.getBanner({ code: bannerCode.bnrHomeNoKtaMobile, data: 'bannerMobile1' }),
      this.getBanner({ code: bannerCode.bnrHomeActvKtaMobile, data: 'bannerMobile2' }),
      this.getBanner({ code: bannerCode.bnrHomeOldKtaMobile, data: 'bannerMobile3' }),
      this.getBanner({ code: bannerCode.bnrDetailBenefitHtml, data: 'detailBenefit' }),
    ])
  }
}
</script>

<style scoped>
.benefit-wrap {
  width: 100%;
  border-radius: 16px;
  padding: 14px;
  background: #ffffff;
}

.benefit-title {
  font-weight: 800;
  color: #374151;
  margin-bottom: 14px;
  font-size: 16px;
}

/* Card base */
.benefit-card {
  position: relative;
  border-radius: 18px;
  overflow: hidden;
}

.content-a {
  position: relative;
  z-index: 2;
  display: flex;
  gap: 18px;
  align-items: center;
  cursor: pointer;
}

.left {
  min-width: 0;
  padding: 20px 0px 20px 20px;
  width: 72%;
}

.vision-top {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.vision-logo {
  height: 24px;
  width: auto;
  opacity: 0.95;
}

.headline-a {
  margin: 0 0 10px 0;
  line-height: 1.05;
  font-weight: 900;
  color: #ffffff;
  letter-spacing: 0.4px;
  text-align: center;
  font-size: 24px;
  margin-bottom: 24px;
  margin-top: 32px;
}

.headline-a .h1 {
  display: block;
}

.headline-a .h2 {
  display: block;
  color: #2fe6d2;
}

.headline-a .h3 {
  display: block;
}

.subtext-a {
  margin: 0 0 14px 0;
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
  line-height: 1.45;
  text-align: center;
}

.benefit-box {
  display: flex;
  flex-direction: column;
  gap: 8px;

  border-radius: 14px;
  border: 2px solid #2fe6d2;
  background: rgba(0, 0, 0, 0.25);
  padding: 12px 16px;

}

.benefit-item-a {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  color: #ffffff;
  font-weight: 800;
  font-size: 10px;
  white-space: nowrap;
}

.benefit-item-a img {
  width: 22px;
  height: 22px;
}

.right {
  display: flex;
  padding: 0;
  padding-top: -12px;
  padding-bottom: -12px;
  height: 100%;
  width: 100%;
  pointer-events: none;
  width: 32%;
}

.phone {
  width: 400px;
  max-width: 100%;
  margin-right: -4px;
  height: auto;
  filter: drop-shadow(0 14px 24px rgba(0, 0, 0, 0.35));
}

.content {
  position: relative;
  z-index: 2;
  color: #ffffff;
  max-width: 520px;
  padding: 24px;
}

.headline {
  font-size: 24px;
  line-height: 1.15;
  margin: 0 0 10px 0;
  font-weight: 900;
}

.subtext {
  margin: 0 0 14px 0;
  color: rgba(255, 255, 255, 0.85);
  font-size: 18px;
  line-height: 1.4;
}

/* Active pill (state B) */
.pill {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(0, 0, 0, 0.15);
  color: rgba(255, 255, 255, 0.95);
  font-weight: 700;
  font-size: 13px;
  margin-bottom: 16px;
}

/* CTA (state B) */
.cta {
  border: none;
  cursor: pointer;
  border-radius: 10px;
  padding: 16px;
  background: #00A593;
  color: #ffffff;
  font-weight: 800;
  font-size: 16px;
  width: fit-content;
  margin-top: 115px;
}

.cta:active {
  transform: translateY(1px);
}

.pattern {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  opacity: 0.55;
  background:
  radial-gradient(circle, rgba(255,255,255,0.20) 1px, rgba(255,255,255,0) 2px) 0 0 / 16px 16px;
}

/* Responsive */
@media only screen and (max-width: 900px) {
  .headline-a .h1,
  .headline-a .h2,
  .headline-a .h3 {
    font-size: 30px;
  }
}

@media only screen and (max-width: 600px) {
  .right {
    justify-content: center;
    margin-top: 8px;
  }

  .headline-a .h1,
  .headline-a .h2,
  .headline-a .h3 {
    font-size: 26px;
  }

  /* state B tetap responsif seperti punyamu */
  .benefit-card {
    border-radius: 16px;
  }

  .content {
    padding: 16px;
  }

  .subtext {
    font-size: 12px;
  }

  .headline {
    font-size: 16px;
  }

  .headline {
    font-size: 20px;
  }

  .cta {
    margin-top: 40px;
  }

  .benefit-box {
    grid-template-columns: 1fr; /* 1 kolom */
    gap: 10px;
  }

  .benefit-item-a:first-child {
    grid-column: auto; /* matikan full width */
    justify-content: flex-start;
  }

  .benefit-item-a {
    justify-content: flex-start;
    white-space: normal; /* biar teks bisa turun baris */
  }
}
</style>
